import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Button } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

const CustomEmailAction = function CustomEmailActions({
  close,
  messageId = null,
  activityId = null,
}) {
  const { setValue } = useFormContext();
  return (
    <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
      <Button variant="text" onClick={close}>
        annulla
      </Button>
      <Button
        variant="contained"
        endIcon={<SendIcon />}
        type="submit"
        onClick={() => {
          setValue('inReplyTo', messageId);
          setValue('parentActivityId', activityId);
        }}
      >
        Invia
      </Button>
    </div>
  );
};

export default CustomEmailAction;
